import history from "../routes/history"
import { getLocalStorage, setLocalStorage, getSessionStorage, setSessionStorage, setValue, getValue } from "./localStorage"

const SUPER_ADMIN = 'SUPER_ADMIN'
const SUPER_ADMIN_VIEW_ONLY = 'SUPER_ADMIN_VIEW_ONLY'
const ACCOUNT_ADMIN = 'ACCOUNT_ADMIN'
const ACCOUNT_USER = 'ACCOUNT_USER'

export const getToken = () => (
  getSessionStorage('auth') || getValue('auth') || getLocalStorage('auth')
)

export const setToken = value => setLocalStorage('auth', value)

export const forwardTo = location => history.push(location)

export const setAccountId = value => setLocalStorage('account_id', value)

export const getAccountId = () => getLocalStorage('account_id')

export const getSessionToken = () => getSessionStorage('auth')

export const setSessionToken = value => setSessionStorage('auth', value)

export const getSessionAccountId = () => getSessionStorage('account_id')

export const setSessionAccountId = value => setSessionStorage('account_id', value)

export const getCookieToken = () => getValue('auth')

export const setCookieToken = value => setValue('auth', value)

export const isSuperAdmin = (roles) => {
  return roles.includes(SUPER_ADMIN)
}

export const hasViewOnlyAccess = (roles) => {
  return roles.includes(SUPER_ADMIN_VIEW_ONLY)
}

export const isAdmin = (roles) => {
  return roles.includes(SUPER_ADMIN) || roles.includes(ACCOUNT_ADMIN)
}
